import React from 'react';
import Chart from 'react-apexcharts';

const EmployeeAssetUsageChart = () => {
  const series = [
    {
      name: "Employee Usage",
      data: [25, 35, 45, 40, 60, 55, 70],
    },
    {
      name: "Asset Usage",
      data: [15, 25, 30, 28, 40, 35, 50],
    },
  ];

  const options = {
    chart: {
      fontFamily: '"Nunito Sans", sans-serif',
      height: 350,
      type: "line",
      dropShadow: {
        enabled: true,
        color: "#000",
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2,
      },
      toolbar: {
        show: false,
      },
    },
    colors: ["#5C9FFF", "#FFB53B"],
    dataLabels: {
      enabled: true,
    },
    stroke: {
      curve: "smooth",
    },
    grid: {
      borderColor: "transparent",
      row: {
        colors: ["rgba(0,0,0,0.2)", "transparent"],
        opacity: 0.5,
      },
    },
    markers: {
      size: 4,
    },
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
      labels: {
        style: {
          colors: Array(7).fill("#a1aab2"),
        },
      },
    },
    yaxis: {
      min: 0,
      max: 100,
      labels: {
        style: {
          colors: Array(7).fill("#a1aab2"),
        },
      },
    },
    tooltip: {
      theme: "dark",
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      floating: true,
      offsetY: -25,
      offsetX: -5,
      labels: {
        colors: "#a1aab2",
      },
    },
  };

  return (
    <div id="employee-asset-usage" className="w-full h-96">
      <Chart options={options} series={series} type="line" height="100%" />
    </div>
  );
};

export default EmployeeAssetUsageChart;
